import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.qainiciante.com.br";
const DEFAULT_IMAGE = `${SITE_URL}/og-banner.png`;

// Metadados por rota via Helmet. Domínio FIXO no canonical/og:url para não
// gerar duplicatas (amplifyapp.com, preview, localhost).
export default function Seo({ title, description, path = "/", noindex = false, image }) {
  const cleanPath = path === "/" ? "/" : `/${String(path).replace(/^\/+|\/+$/g, "")}`;
  const url = `${SITE_URL}${cleanPath}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="QA Iniciante" />
      <meta property="og:locale" content="pt_BR" />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
